// src/views/Responders/Responders.js
//
// Transit Watch Console - Responders
//
// Modern responder operations container.
//
// The original Responders page was a legacy class component
// built primarily around responder-location map functionality.
// The new Responders architecture separates responder operations
// into focused sub-tabs:
//
//   Shifts  - responder shift sessions and vehicle checks
//   Map     - future rebuilt responder location map
//   Reports - future responder-specific reporting
//
// Access to this page continues to be controlled by the existing
// top-level Responders navigation permission.

import React, { useState } from "react";
import { useSelector } from "react-redux";
import ResponderShifts from "./ResponderShifts";

import "./Responder.css";

export default function Responders() {
  const agencyStubs = useSelector((state) => state.agencyStubs);
  const agency = useSelector((state) => state.agency);

  const [activeResponderTab, setActiveResponderTab] =
    useState("shifts");

  const selectedAgencyId =
    agencyStubs.selectedAgencyId ||
    agency.details?._id ||
    "";

  return (
    <div className="container-fluid">

      {/* RESPONDER SUB-TABS */}
      <div className="row">
        <div className="col-12">
          <ul
            className="nav nav-tabs"
            id="responder_tabs"
            role="tablist"
          >
            <li
              className="nav-item"
              role="presentation"
            >
              <button
                type="button"
                className={`nav-link ${
                  activeResponderTab === "shifts"
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  setActiveResponderTab("shifts")
                }
              >
                Shifts
              </button>
            </li>

            <li
              className="nav-item"
              role="presentation"
            >
              <button
                type="button"
                className={`nav-link ${
                  activeResponderTab === "map"
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  setActiveResponderTab("map")
                }
              >
                Map
              </button>
            </li>

            <li
              className="nav-item"
              role="presentation"
            >
              <button
                type="button"
                className={`nav-link ${
                  activeResponderTab === "reports"
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  setActiveResponderTab("reports")
                }
              >
                Reports
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* SHIFTS */}
{activeResponderTab === "shifts" && (
  selectedAgencyId ? (
    <ResponderShifts
      agencyId={selectedAgencyId}
    />
  ) : (
    <div className="responder-shifts-view">
      <h2>Responder Shifts</h2>
      <p>No agency is currently selected.</p>
    </div>
  )
)}

      {/* MAP */}
      {activeResponderTab === "map" && (
        <div className="responder-map-view">
          <h2>Responder Map</h2>
          <p>
            Responder location mapping will be rebuilt
            here using the current Console architecture.
          </p>
        </div>
      )}

      {/* REPORTS */}
      {activeResponderTab === "reports" && (
        <div className="responder-reports-view">
          <h2>Responder Reports</h2>
          <p>
            Responder-specific reports and history will
            appear here.
          </p>
        </div>
      )}

    </div>
  );
}